import http from '@/http';

export default {

    list() {
        return http.get('/admin');
    },

    expireSubstitutes() {
        return http.post('/admin/expireSubstitutes');
    },

    syncGdp() {
        return http.post('/admin/syncGdp');
    },

    report() {
        return http.get('/admin/report');
    },

    serverData() {
        return http.get('/admin/serverData');
    },
};



// WEBPACK FOOTER //
// ./src/api/admin.js